/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { ConfigRevision } from '@/client';
import { ConfigRevisionsList } from '@/components/ConfigWizardOverlay/ConfigRevisionsList';
import { usePaginatedConfigRevisionsQuery } from '@/hooks/query/usePaginatedConfigRevisionsQuery';
import { Card } from '@/primitives/Card';

export type SelectRevisionStepProps = {
  revisionsQuery: ReturnType<typeof usePaginatedConfigRevisionsQuery>;
  selectedRevision: ConfigRevision | undefined;
  onRevisionSelect: (revision: ConfigRevision | undefined) => void;
  getConfigRevisionPath: (revision: ConfigRevision) => string;
};

export function SelectRevisionStep({
  revisionsQuery,
  selectedRevision,
  onRevisionSelect,
  getConfigRevisionPath,
}: SelectRevisionStepProps) {
  return (
    <Card dataTestId="fleet-wizard-select-revision" padding="sm" bordered style={{ width: '100%' }}>
      <ConfigRevisionsList
        onFilterAndSortChange={revisionsQuery.updateQueryParams}
        configRevisionsQuery={revisionsQuery}
        getConfigRevisionPath={getConfigRevisionPath}
        onConfigRevisionSelect={onRevisionSelect}
        defaultConfigRevision={selectedRevision}
      />
    </Card>
  );
}
